<template>
    <router-link class="text-decoration-none black--text"
                 :to="{name: 'product_page', params: {product_id: product.id}}">
        <div @mouseleave="activeImage = 0" class="p-images-container">
            <product-heart-button class="p-image-heart" :product-id="product.id"/>
            <v-carousel v-model="activeImage" hide-delimiters :show-arrows="false" :continuous="false" class="p-images">
                <v-carousel-item
                    v-for="(image, index) in product.images"
                    :key="index"
                    :src="image"
                    :disabled="dense"
                    contain
                    class="p-image"
                />
            </v-carousel>
            <div v-if="hovered && !dense" class="p-image-hover-container hidden-sm">
                <div v-for="(_, index) in product.images" :key="index" class="p-image-hover"
                     @mouseenter="activeImage = index"></div>
            </div>
            <div v-if="product.images.length > 1 && !dense" class="p-delimiters-container">
                <div class="p-delimiters" :style="{'transform': transform}">
                    <div v-for="(_, index) in product.images" :key="index" class="p-delimiter"
                         :class="{'active': index === activeImage}"></div>
                </div>
            </div>
            <div v-if="!dense" class="p-labels">
                <div v-if="product.options.length !== 0" class="text-left">
                    <v-chip color="info" x-small label>Штучно</v-chip>
                </div>
                <div v-if="product.wholesale_options.length !== 0" class="text-left">
                    <v-chip color="warning" x-small label>Упаковка</v-chip>
                </div>
            </div>
        </div>
        <div class="pl-1 mt-1" :class="{'mb-3': !dense}">
            <v-row v-show="!dense" class="flex-nowrap" no-gutters>
                <v-col>
                    <div class="p-name">
                        {{ product.name || 'Без наименования' }}
                    </div>
                    <div class="p-freshness mt-n1">
                        {{ places }} · {{ freshness }}
                    </div>
                </v-col>
            </v-row>
            <div
                class="p-price"
                :class="{'body-2 font-weight-bold': dense}"
            >
                {{ priceLabel }}
            </div>
        </div>
    </router-link>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
import ProductHeartButton from "@/components/catalog/ProductHeartButton.vue";

export default {
    name: "ProductCard",
    components: {ProductHeartButton},
    props: {
        product: {
            type: Object,
            required: true
        },
        dense: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            icon_link: mdiOpenInNew,
            activeImage: 0,
        }
    },
    computed: {
        hovered() {
            return !['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
        },
        transform() {
            if (this.activeImage <= 1) {
                return `translateX(0px)`;
            } else if (this.activeImage >= this.product.images.length - 1) {
                return `translateX(-${(this.product.images.length - 3) * 7}px)`;
            } else {
                return `translateX(-${(this.activeImage - 1) * 7}px)`;
            }
        },
        places() {
            return this.product.seller.places.map(obj => obj.name).join(", ")
        },
        retailPrice() {
            if (this.product.options.length === 0) return null;
            return Math.min(...this.product.options.map(option => Number(option.price)));
        },
        wholesalePrice() {
            if (this.product.wholesale_options.length === 0) return null;
            return Math.min(...this.product.wholesale_options.map(option => Number(option.price)));
        },
        priceLabel() {
            let priceLabel = "Нет цены";
            if (this.retailPrice !== null && this.wholesalePrice !== null && !this.dense) {
                if (this.retailPrice === this.wholesalePrice) {
                    return `${this.retailPrice}₽`;
                }
                return `${this.wholesalePrice} — ${this.retailPrice}₽`;
            }
            if (this.retailPrice !== null) {
                return `${this.retailPrice}₽`;
            }
            if (this.wholesalePrice !== null) {
                return `${this.wholesalePrice}₽`;
            }
            return priceLabel;
        },
        freshness() {
            const publishedAt = new Date(this.product.published_at);
            const now = new Date();
            const diff = now - publishedAt;
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            if (days < 1) {
                return 'Сегодня';
            } else if (days < 2) {
                return 'Вчера';
            } else if (days < 30) {
                return `${days}д. назад`;
            } else {
                return 'Более месяца назад';
            }
        }
    },
    mounted() {
        // console.log(this.product)
    }
}
</script>

<style scoped>
.p-image-heart {
    position: absolute;
    top: 4px;
    right: 2px;
    z-index: 1;
}

.p-image-hover-container {
    left: 0;
    top: 0;
    position: absolute;
    display: flex;
    height: 100%;
    width: 100%;
}

.p-image-hover {
    flex: 0 1 100%;
}

.p-delimiters-container {
    position: absolute;
    bottom: 4px;
    right: 4px;
    width: 20px;
    overflow: hidden;
    display: flex;
}

.p-delimiters {
    gap: 3px;
    display: flex;
    justify-content: end;
    align-items: center;
    transition: transform .3s;
}

.p-delimiter {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(33, 32, 31, .3);
    border: .5px solid hsla(0, 0%, 100%, .5);
    flex-shrink: 0;
    transition: all .3s;
}

.p-delimiter.active {
    width: 6px;
    height: 6px;
    border: 1px solid white;
    background-color: #222;
}

.p-images-container {
    position: relative;
    padding-bottom: 133%;
    background-color: rgba(0, 0, 0, .045);
    border-radius: 7px;
    overflow: hidden;
}

.p-images {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% !important;
}

.p-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-image >>> .v-image {
    height: 100% !important;
}

.p-name {
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.p-price {
    font-size: 20px;
    font-weight: 700;
}

.p-freshness {
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, .5);
}

.p-labels {
    display: flex;
    flex-direction: column;
    position: absolute;
    line-height: normal;
    bottom: 4px;
    left: 4px;
}
</style>